module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/qr-code-plp-marketting-tile-1188731ec675915512f162ec2289b296.jpg";